module.exports = __webpack_public_path__ + "static/latitude-box-id-ec49beba16e43ba01845ac3facef212a.webp";